const JANUARY = 1;
const FEBRUARY = 2;
const MARCH = 3;
const APRIL = 4;
const MAY = 5;
const JUNE = 6;
const JULY = 7;
const AUGUST = 8;
const SEPTEMBER = 9;
const OCTOBER = 10;
const NOVEMBER = 11;
const DECEMBER = 12;
export const MonthValues = {
  JANUARY,
  FEBRUARY,
  MARCH,
  APRIL,
  MAY,
  JUNE,
  JULY,
  AUGUST,
  SEPTEMBER,
  OCTOBER,
  NOVEMBER,
  DECEMBER
};
export const MonthTranslationKeys = {
  [JANUARY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.january',
  [FEBRUARY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.february',
  [MARCH]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.march',
  [APRIL]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.april',
  [MAY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.may',
  [JUNE]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.june',
  [JULY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.july',
  [AUGUST]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.august',
  [SEPTEMBER]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.september',
  [OCTOBER]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.october',
  [NOVEMBER]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.november',
  [DECEMBER]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.months.december'
};